import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ClinicalReportEditComponent } from './edit.component';
import { InputTextModule } from '../../../../components/input/input-text';
import { InputSelectModule } from '../../../../components/input/input-select';
import { InputCheckboxModule } from '../../../../components/input/input-checkbox';
import { LanguageStringObjectSelectionModule } from '../../../../components/language-string/language-string-object-selection';

const ROUTES: Routes = [
  { path: '', component: ClinicalReportEditComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    InputSelectModule,
    InputCheckboxModule,
    LanguageStringObjectSelectionModule,
    RouterModule.forChild(ROUTES),
  ],
  declarations: [ClinicalReportEditComponent],
  exports: [ClinicalReportEditComponent],
})
export class EditModule {}
